import {
  IconId,
  IconAlertTriangle,
  IconEye,
  IconLock,
  IconSettings,
  type Icon as TablerIcon,
} from "@tabler/icons-react";


export type FlagCategory =
  | "PII"
  | "Conduct"
  | "Witness"
  | "Restricted"
  | "Technical";


export const CATEGORY_CONFIG: Record<
  FlagCategory,
  { label: string; color: string; icon: TablerIcon }
> = {
 PII:        { label: "PII",        color: "#F59E0B", icon: IconId },
  Conduct:    { label: "Conduct",    color: "#EF4444", icon: IconAlertTriangle },
  Witness:    { label: "Witness",    color: "#06B6D4", icon: IconEye },
  Restricted: { label: "Restricted", color: "#8B5CF6", icon: IconLock },
  Technical:  { label: "Technical",  color: "#6B7280", icon: IconSettings },
};